import { clearWorkflows } from '../utils/workflowUtils';
import { useEffect } from 'react';

export const useRegisterWorkflowConfigs = (registerCallback: Function) => {
    useEffect(() => {
        clearWorkflows();

        registerCallback();
        /* eslint-disable-next-line react-hooks/exhaustive-deps --
         * See aka.ms/mini-lint-errors
         *	> React Hook useEffect has a missing dependency: 'registerCallback'. Either include it or remove the dependency array. If 'registerCallback' changes too often, find the parent component that defines it and wrap that definition in useCallback. */
    }, []);
};
